// @flow

import React from 'react'
import styled from 'styled-components'
import { Radio } from 'antd'
import { mediaMin } from 'frontend_core/dist/styles/media'
import { spacing, fontSize } from 'frontend_core/dist/styles/variables'
import Colors from 'components/styles/colors'

const FullListItem = styled.li`
  &:not(:first-of-type) {
    margin-top: ${spacing.medium_2}px;
  }
`
const Text = styled.span`
  display: block;
  font-size: ${fontSize.small_2}px;
  margin-top: ${spacing.tiny}px;
  ${mediaMin.phone`
    display: inline-block;
    font-size: ${fontSize.medium}px;
    margin: 0 0 0 ${spacing.tiny}px;
  `};
`
const Image = styled.img`
  display: inline-block;
  height: 14px;
  width: auto;
  margin-right: ${spacing.small}px;
  vertical-align: middle;
`

export type PropTypes = {
  radioList: Array<{
    number: string | number,
    accountHolder: string,
    expirationDate: string,
    value: string | number,
    srcCardImage?: string,
  }>,
  name: string,
  selectedValue?: ?number | string,
  onChange: Function,
}

const RadioGroup = Radio.Group

export default function RadioListCreditcard(props: PropTypes) {
  return (
    <ul>
      <RadioGroup
        onChange={e => props.onChange(e.target.value)}
        value={props.selectedValue}
      >
        {props.radioList.map((radio, index) => (
          <FullListItem key={index}>
            <Radio value={radio.value} name={props.name}>
              {radio.srcCardImage && <Image src={radio.srcCardImage} />}
              {radio.number}
              <Text>
                {i18n.t(
                  'page.dashboard.reservation.selectPayMethod.accountHolder',
                )}
                ：{radio.accountHolder}
              </Text>
              <Text>
                {i18n.t('page.shared.expirationDate')}：{radio.expirationDate}
              </Text>
            </Radio>
          </FullListItem>
        ))}
      </RadioGroup>
    </ul>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/RadioListCreditcard/index.jsx